module.exports = __webpack_public_path__ + "img/微信图片_20210131164336.3a6a446b.png";